import { CSSProperties, ReactNode, useMemo } from 'react'
import {
  Container as SemanticContainer,
  StrictContainerProps,
} from 'semantic-ui-react'

import Card from './Card'
import { Colors } from '../../styles/theme'
import { DeviceWidth, useIsDeviceWidth } from '../../utils/deviceWidthHelpers'

const Container = ({
  children,
  isFullWidthTablet,
  variant,
  centerContent,
  ...rest
}: {
  children: ReactNode
  isFullWidthTablet?: boolean
  variant?: 'regular' | 'disabled' | 'emphasis' | 'raised' | 'noShadow'
  id?: string
  centerContent?: boolean
} & StrictContainerProps) => {
  const isTablet = useIsDeviceWidth(DeviceWidth.tablet)
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  const containerStyle = useMemo(() => {
    const style: CSSProperties = centerContent
      ? { display: 'flex', justifyContent: 'center' }
      : {}
    if (isTablet && isFullWidthTablet) {
      style.width = '100%'
    }
    if (isMobile) {
      style.backgroundColor = Colors.white
      style.width = '100%'
    }
    return style
  }, [isTablet, isFullWidthTablet, isMobile, centerContent])

  return (
    <SemanticContainer
      {...rest}
      style={containerStyle}
      className="card-container"
    >
      <Card
        backgroundColor="white"
        style={isMobile ? { padding: '32px 24px' } : {}}
        variant={variant}
      >
        {children}
      </Card>
    </SemanticContainer>
  )
}

export default Container
